import { render, staticRenderFns } from "./importEmployee.vue?vue&type=template&id=23caff3d&scoped=true"
import script from "./importEmployee.vue?vue&type=script&lang=js"
export * from "./importEmployee.vue?vue&type=script&lang=js"
import style0 from "./importEmployee.vue?vue&type=style&index=0&id=23caff3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23caff3d",
  null
  
)

export default component.exports